import {menu} from "./menu";
import {slider} from "./slider";
import {bag} from "./bag";
import {map} from "./map";
import {scroll} from "./scroll";
import {popup} from "./popup";
import {acc} from "./acc";

document.addEventListener("DOMContentLoaded", (event) => {
  // console.log("DOM fully loaded and parsed");
  // modal();
  slider()
  menu();
  bag();
  map();
  scroll();
  acc();
  popup();
});
